import { BlobProvider } from "@react-pdf/renderer";
import { useState } from "react";
import { MonthlyAttendanceAllUsersReport } from "./MonthlyAttendanceAllUsersReport";

export default function MonthlyAttReportAllUsersBtn({
  btnClasses,
  selectedReport,
}) {
  /*   All States
   ********************************************* */
  const [showPdf, setShowPdf] = useState(false);
  const [error, setError] = useState(null);

  const [showDownloadLoading, setShowDownloadLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const handleGenerateReport = () => {
    setShowDownloadLoading(true);
    let timeoutId = setTimeout(() => {
      setShowPdf(true);
      setError(null); // Reset error state
      setShowDownloadLoading(false);
      clearTimeout(timeoutId); // Clear the timeout to prevent memory leaks
    }, 1000); // Simulate a delay for PDF generation
  };

  const handleError = (err) => {
    console.error("PDF generation error:", err);
    setError("Failed to generate PDF. Please try again.");
    setShowPdf(false);
  };

  /*   All UseEffects
   ********************************************* */

  return (
    <>
      {error && <div className="text-danger small mb-2">{error}</div>}

      {showPdf ? (
        <BlobProvider
          document={
            <MonthlyAttendanceAllUsersReport selectedReport={selectedReport} />
          }
        >
          {({ url, blob, loading, error: pdfError }) => {
            if (pdfError) {
              handleError(pdfError);
            }

            const isDisabled = loading || pdfError || !blob || !url;
            return (
              <span className="d-inline-flex gap-2">
                <a
                  href={isDisabled ? "#" : url}
                  download={`Monthly-Attendance-Report-${new Date().toISOString().slice(0, 10)}.pdf`}
                  className={btnClasses}
                  onClick={(e) => {
                    if (isDisabled) e.preventDefault();
                  }}
                >
                  <i className="mdi mdi-download"></i> Download Report
                </a>
                <a
                  href={isDisabled ? "#" : url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={btnClasses}
                  onClick={(e) => {
                    if (isDisabled) e.preventDefault();
                  }}
                >
                  <i className="mdi mdi-eye"></i> View Report
                  {isDisabled && (
                    <div
                      className="spinner-border spinner-border-sm text-white ms-2 mb-1"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </a>
              </span>
            );
          }}
        </BlobProvider>
      ) : (
        <button
          className={btnClasses}
          disabled={showDownloadLoading}
          onClick={(e) => {
            handleGenerateReport(e);
          }}
        >
          Generate Report
          {showDownloadLoading && (
            <div
              className="spinner-border spinner-border-sm text-white ms-2 mb-1"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </button>
      )}
    </>
  );
}
